import { render, staticRenderFns } from "./FileModalForm.vue?vue&type=template&id=2724dba2"
import script from "./FileModalForm.vue?vue&type=script&lang=js"
export * from "./FileModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports